import { createContext, useContext } from 'react';
import { DashboardOverview } from '../../types/dashboard';

export interface DashboardContextProps {
  dashboard: DashboardOverview;
  selectedOutletId?: string | null;
  scopeLabel: string;
  outletCountInScope: number;
  period: number;
  setPeriod: (period: number) => void;
  loadingStates: {
    summary: boolean;
    recent: boolean;
    payments: boolean;
    departments: boolean;
  };
}

export const DashboardContext = createContext<DashboardContextProps | null>(
  null,
);

export const useDashboardContext = () => {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error(
      'useDashboardContext must be used within DashboardProvider',
    );
  }
  return context;
};
